module.exports = __webpack_public_path__ + "img/wa_logo3.44f8c79c.png";